const cvBluePetrolColor = "#96B0BD";
const cvBrownColor = "#C8B79F";
const cvGreenColor = "#93D4C1";
const cvVioletColor = "#BC9FFF";
const cvDarkViolet = "#9788AC";

export { cvBluePetrolColor, cvBrownColor, cvGreenColor, cvVioletColor, cvDarkViolet };
